/**
 * Temporary... We should go ahead and finalized the structure of account/client - project inheritance
 * and then refactor this action accordingly.
 */

import { createAction, props } from "@ngrx/store";

export const rejectCurrentProject = createAction(
  'Account.RejectCurrentProject',
  props<{ error: unknown }>()
);
